export default __webpack_public_path__ + "static/media/female-circle.png";